module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layour-card",
    style: (_vm.styles)
  }, [_c('div', {
    ref: "title",
    staticClass: "card-title"
  }, [(typeof _vm.title == "string") ? [_c('span', {
    staticClass: "title-text",
    style: (_vm.getFontStyle())
  }, [_vm._v(_vm._s(_vm.title))])] : _vm._l((_vm.title), function(t, i) {
    return _c('span', {
      class: _vm.getTitleClass(i)
    }, [_vm._v("\n         " + _vm._s(t) + "\n      ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "shadow-bg"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57a4722e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/layout-card/index.vue
// module id = 236
// module chunks = 0